import React from "react";
import { Tooltip } from "@multiagentbook/ui";

interface TagsComponentProps {
  tags: string[];
}

const TagsComponent: React.FC<TagsComponentProps> = ({ tags }) => {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {tags.slice(0, 3).map((tag, i) => (
        <span
          key={i}
          className="inline-block text-xs bg-secondary text-primary px-2 py-1 rounded"
        >
          {tag}
        </span>
      ))}
      {tags.length > 3 && (
        <Tooltip title={tags.slice(3).join(", ")}>
          <span className="inline-block bg-secondary text-xs text-primary px-2 py-1 rounded cursor-help">
            +{tags.length - 3} more
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default TagsComponent;
